import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { URLSearchParams } from '@angular/http';
import { MatSnackBar } from '@angular/material';

import { oAuth } from '../providers/oAuth';
import { Pharmacies } from '../dataObjects/Pharmacies';
import { DeptCodes, ClassCodes, VendorCodes } from '../dataObjects/Customer';
import { Reports, Report, ReconcileItemReportFilter, RxqOneReconcileItemReportRequest } from '../dataObjects/ReportCenter';

import { GlobalVariable } from '../common/global';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource } from '@angular/material';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-bzq-reconcile-item-filter',
  templateUrl: './bzq-reconcile-item-filter.component.html',
  styleUrls: ['./bzq-reconcile-item-filter.component.css']
})
export class BzqReconcileItemFilterComponent implements OnInit {

  ReconcileItemReportFilter: ReconcileItemReportFilter;
  PharmaciesSelectedValue: string

  selectedReport: Report;
  pharms: Pharmacies[];
  opened: boolean = true;
  Reportreturnimage: string;
  ReportOptionValue: number;
  selectedIndex: any;
  loading: boolean;
  ReportOptionDD: any;

  constructor(private http: HttpClient, public snackBar: MatSnackBar, public dialog: MatDialog, public dialogRef: MatDialogRef<boolean>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.PharmaciesSelectedValue = this.data.pharm;
    this.ReconcileItemReportFilter = this.data.ReconcileItemReportFilter;
    this.selectedReport = this.data.selectedReport;
    this.pharms = this.data.pharms;
    this.ReconcileItemReportFilter.RunReport = false;

    this.ReportOptionDD = [
      { value: '1', viewValue: 'PDF' },
      { value: '2', viewValue: 'JPEG' },
      { value: '3', viewValue: 'CSV' }
    ]
  }

  PharmChanged() {
    this.PopDeptCodes();
    this.PopClassCodes();
    this.PopVendorCodes();
  }

  runReport() {
    this.ReconcileItemReportFilter.RunReport = true;
    this.dialogRef.close();
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 40000,
    });
  }

  closeDlg() {
    this.dialogRef.close();
  }

  PopDeptCodes() {

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    var body = JSON.stringify(this.PharmaciesSelectedValue)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneDeptCodes", body.toString(), options)
      .subscribe(
        (response) => {
          const resp = <[DeptCodes]>response
          this.ReconcileItemReportFilter.DeptList = resp;
        },
        (err) => {
          /* this function is executed when there's an ERROR */

        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
        }
      );
  }

  PopClassCodes() {

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    var body = JSON.stringify(this.PharmaciesSelectedValue)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneClassCodes", body.toString(), options)
      .subscribe(
        (response) => {
          const resp = <[ClassCodes]>response
          this.ReconcileItemReportFilter.ClassList = resp;

        },
        (err) => {
          /* this function is executed when there's an ERROR */

        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
        }
      );
  }

  PopVendorCodes() {

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    var body = JSON.stringify(this.PharmaciesSelectedValue)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneVendorCodes", body.toString(), options)
      .subscribe(
        (response) => {
          const resp = <[VendorCodes]>response
          this.ReconcileItemReportFilter.VendorList = resp;
        },
        (err) => {
          /* this function is executed when there's an ERROR */

        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
        }
      );
  }

  setDate(date: any) {
    var s: String = date.toLocaleString();
    s = s.split(",")[0];
    return s;
  }
  ReconcileItemReport(download: boolean) {
    window.scrollTo(0, 0);
    this.loading = true;
    this.opened = false;

    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    if (download == false) {
      this.ReconcileItemReportFilter.ReportOption = null;
      this.Reportreturnimage = null;
      this.ReportOptionValue = null;
    }

    var selectedTemplate;

    let ReconcileItemRequest: RxqOneReconcileItemReportRequest = {
      Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
      ReconcileItemValues: this.ReconcileItemReportFilter
    };

    ReconcileItemRequest.ReconcileItemValues.ReportTemplate = this.selectedReport.ReportPath;
    ReconcileItemRequest.ReconcileItemValues.ReportOption = this.ReportOptionValue;
    if (ReconcileItemRequest.ReconcileItemValues.DateEnd)
      ReconcileItemRequest.ReconcileItemValues.DateEnd = this.setDate(ReconcileItemRequest.ReconcileItemValues.DateEnd);
    if (ReconcileItemRequest.ReconcileItemValues.DateStart)
      ReconcileItemRequest.ReconcileItemValues.DateStart = this.setDate(ReconcileItemRequest.ReconcileItemValues.DateStart);

    if (this.PharmaciesSelectedValue.toString() == '0' && this.ReconcileItemReportFilter.ReportOption != null) {

      var body = JSON.stringify(ReconcileItemRequest)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneBZQReconcileItemReport", body.toString(), options)
        .subscribe(
          (response) => {
            if (this.ReconcileItemReportFilter.ReportOption == null) {
              this.Reportreturnimage = <string>response;
            }
            else {

              if (this.ReconcileItemReportFilter.ReportOption == 1) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);


                var blob = new Blob([byteArray], { type: 'applicaton/pdf' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".pdf");

              }
              if (this.ReconcileItemReportFilter.ReportOption == 2) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'image/jpg' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".jpg");

              }

              if (this.ReconcileItemReportFilter.ReportOption == 3) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'text/csv' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".csv");

              }

            }
          },
          (err) => {
            /* this function is executed when there's an ERROR */

            if (err.error.includes("Record not Found")) {
              this.openSnackBar("No records found.", "Warning");
            }
            else {
              this.openSnackBar("There was an issue with this request", "Error");
            }

            this.loading = false;

          },
          () => {
            /* this function is executed when the observable ends (completes) its stream */
            this.loading = false;
            this.openSnackBar("Doctor has completed.", "OK");
          }
        );
    }

    else {
      var body = JSON.stringify(ReconcileItemRequest)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneBZQReconcileItemReport", body.toString(), options)
        .subscribe(
          (response) => {
            if (this.ReconcileItemReportFilter.ReportOption == null) {
              this.Reportreturnimage = <string>response;
            }
            else {

              if (this.ReconcileItemReportFilter.ReportOption == 1) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);


                var blob = new Blob([byteArray], { type: 'applicaton/pdf' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".pdf");

              }
              if (this.ReconcileItemReportFilter.ReportOption == 2) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'image/jpg' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".jpg");

              }

              if (this.ReconcileItemReportFilter.ReportOption == 3) {

                var byteCharacters = atob(<string>response);

                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], { type: 'text/csv' });

                saveAs(blob, this.selectedReport.ReportName.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".csv");

              }

            }
          },
          (err) => {
            /* this function is executed when there's an ERROR */

            if (err.error.includes("Record not Found")) {
              this.openSnackBar("No records found.", "Warning");
            }
            else {
              this.openSnackBar("There was an issue with this request", "Error");
            }

            this.loading = false;

          },
          () => {
            /* this function is executed when the observable ends (completes) its stream */
            this.loading = false;
            this.openSnackBar("Reconcile Item has completed.", "OK");
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/bzq-reconcile-item-filter/bzq-reconcile-item-filter.component.ts